import React from 'react'
import styles from './style.module.scss'
import PropTypes from 'prop-types'
import { useRouter } from 'next/router'

function F1Heading({ title }) {
  const router = useRouter()
  return (
    <>
      <div className={styles.heading}>
        <div className={styles.line}></div>
        {router.pathname === '/formula1-racing' ? <h2 className={styles.title}>{title}</h2> : <h1 className={styles.title}>{title}</h1>}
      </div>
    </>
  )
}

F1Heading.propTypes = {
  title: PropTypes.string
}

export default F1Heading
